export function isGuestUrlPermissionLevel(permLevel) {
    // Based on the permission level, we can detect whether it is shared through guest url
    switch (permLevel) {
        case 4 /* AnonymousEdit */:
        case 3 /* AnonymousView */:
        case 6 /* OrganizationEdit */:
        case 5 /* OrganizationView */:
            return true;
        default:
            return false;
    }
}
//# sourceMappingURL=isGuestUrlPermissionLevel.js.map